import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { fetch as fetchMap, toggleMapView, } from 'actions/map';

import * as phases from 'constants/phases';
import { IAppState } from 'types/app';


type StateProps = ReturnType<typeof mapStateToProps>;
interface OwnProps {
  dispatch: Function,
  className?: string,
  disabled?: boolean,
}
type Props = OwnProps & StateProps & RouteComponentProps;

class TravelButton extends Component<Props> {
  static displayName = 'TravelButton';

  handleClick = () => {
    const { dispatch, shouldMapUpdate } = this.props;
    if (shouldMapUpdate) {
      dispatch(fetchMap());
    }
    dispatch(toggleMapView());
  };

  render() {
    const { className, disabled, history } = this.props;
    return (
      <button
        className={classnames('button button--primary', className)}
        onClick={this.handleClick}
        disabled={disabled || history.location.pathname !== '/'}
        type="button"
      >
        Travel
      </button>
    );
  }
}

const mapStateToProps = ({
  map: { canTravel, shouldUpdate },
  storylet: { phase },
}: IAppState) => ({
  shouldMapUpdate: shouldUpdate,
  disabled: !(canTravel && phase === phases.AVAILABLE),
});

export default withRouter(connect(mapStateToProps)(TravelButton));